/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 */
import React from 'react';
import { CustomAddChip } from '../../../../components/CustomAddChip';
import { PersonChipBlack } from '../../../../components/buttons/IconButtons';

/**
 * First step of the invite external user modal, the logged resident searches the
 * visitor by name or email between the ones already registered and picks the
 * type of visitor they are inviting on the cards.
 *
 * @param {Object} props
 * @param {Function} props.t - Localization function.
 * @param {Object} [props.visitorType] - Visitor type already picked, null while none is.
 * @param {Array<Object>} props.visitorTypes - Visitor types offered, one card each.
 * @param {boolean} [props.disabled] - Locks the cards on the type of the visitor picked.
 * @param {Function} props.handleSelectVisitorType - Keeps the visitor type of the card clicked.
 * @param {Array<Object>} props.visitors - Visitors already registered the chip filters.
 * @param {Array<Object>} props.selectedVisitors - Visitor picked, empty while none is.
 * @param {Function} props.handleSelectVisitors - Fills the contact with the visitor picked.
 */
const InviteExternalUserStep1 = ({
    t,
    visitorType,
    visitorTypes,
    disabled = false,
    handleSelectVisitorType,
    visitors,
    selectedVisitors,
    handleSelectVisitors
}) => {

    return (
        <div className={'row'}>
            <div className={'col-12'}>
                <p className={'font-color-general-950 fs-14px text-center'}>
                    {t('provide_the_required_information_to_create_and_send_the_visitor_invitation')}
                </p>
            </div>

            <div className={'col-12'}>
                <p className={'font-color-general-950 ibl-font-w-600 fs-14px text-center my-4 text-uppercase'}>
                    {t('search_if_the_visitor_is_already_registered')}
                </p>
            </div>

            {/* The visitor picked fills the contact of the next step, it can
                still be typed by hand when the visitor is not registered yet */}
            <div className={'col-12'}>
                <CustomAddChip
                    autocompleteId={'slt_ieu_visitor'}
                    buttonId={'btn_ieu_visitor'}
                    label={'visitor'}
                    data={visitors}
                    selectedList={selectedVisitors}
                    setSelectedList={handleSelectVisitors}
                    maxLength={1}
                    required={false}
                    hideButton={true}
                    showRenderOption={true}
                    chipIcon={PersonChipBlack}
                />
            </div>

            <div className={'col-12'}>
                <p className={'font-color-general-950 ibl-font-w-600 fs-14px text-center my-4 text-uppercase'}>
                    {t('choose_the_type_of_visitor')}
                </p>
            </div>

            {/* The type of the visitor already registered is the one of their
                card, it is only changed by removing or changing that visitor */}
            {visitorTypes.map((type) => (
                <div key={type.key} className={'col-sm-12 col-md-3 mb-2'}>
                    <div
                        id={`btn_ieu_${type.key.toLowerCase()}`}
                        className={`h-100 p-16px border-radius-8px d-flex flex-column align-items-center justify-content-center
                                ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
                                ${visitorType?.key === type.key
                            ? 'background-primary-50 border-full-primary-300'
                            : 'background-shades-50 border-full-shades-100'}`}
                        onClick={() => !disabled && handleSelectVisitorType(type)}
                    >
                        <div className={`${visitorType?.key === type.key ? 'icon-color-primary-600': 'icon-color-shades-700'}`}>{type.icon}</div>
                        <p className={'font-color-general-950 ibl-font-w-600 fs-14px text-center mt-2 mb-0'}>
                            {t(type.translation)}
                        </p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default InviteExternalUserStep1;
